<div class="row">
  <div class="col-md-4"></div>
  <div class="col-md-8">
    <div style="padding-left: 0.75rem; padding-right: 0.75rem;">
      <button type="button" class="btn btn-outline-primary col-md-5 mr-05" (click)="navigateToPrevTasks()">
        {{'TASK_RECORD_JUMP_TO_PREV' | translate}}
      </button>
      <button type="button" class="btn btn-outline-primary col-md-6" (click)="navigateToNextTasks()">
        {{'TASK_RECORD_JUMP_TO_NEXT' | translate}}
      </button>
    </div>
  </div>
</div>
